import React from 'react';
import { cn } from 'lib/utils';

/**
 * SidebarSection - A section divider with optional title for sidebar navigation
 * Shows title when expanded, shows a simple divider line when collapsed
 */
export default function SidebarSection({
  title,
  collapsed = false,
  className,
  children,
}) {
  return (
    <section className={cn('mt-5', className)}>
      {/* Section Header */}
      {collapsed ? (
        // Collapsed: Simple divider line
        <div className="mx-auto mb-2 h-px w-8 bg-[var(--rely-border-subtle)]" />
      ) : (
        // Expanded: Title with subtle line
        <div className="mb-2 flex items-center gap-2 px-3">
          <span className="max-w-[12rem] truncate text-[11px] font-semibold leading-none text-[var(--rely-text-muted)]">
            {title}
          </span>
          <div className="h-px flex-1 bg-[var(--rely-border-subtle)]" />
        </div>
      )}

      {/* Section Content */}
      {children}
    </section>
  );
}
